import { forwardRef } from 'react';

import './input.scss';

export const Input = forwardRef(
  (
    {
      label,
      type,
      name,
      value,
      placeholder,
      onChange,
      onFocus,
      required,
      filled,
      bordered,
      style,
      icon: Icon,
      clearIcon: ClearIcon,
      error,
      display = false
    },
    ref
  ) => {
    const handleOnChange = (event) => {
      const { name, value } = event.target;
      onChange({ name, value });
    };

    return (
      <div
        className={`form-input ${filled ? 'form-input--filled' : ''} ${bordered ? 'form-input--bordered' : ''} 
      ${!!error ? 'form-input--error' : ''}`}
        style={style}
      >
        {label && (
          <label htmlFor={name}>
            {label}
            {required && !display ? <span> *</span> : ''}
          </label>
        )}
        <div>
          {Icon && <Icon width={20} height={20} />}
          {display && type === 'date' ? (
            <span>
              {value
                ? new Date(value).toLocaleDateString('en-ZA', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                  })
                : ''}
            </span>
          ) : (
            <input
              ref={ref}
              type={type}
              id={name}
              name={name}
              value={value}
              placeholder={placeholder}
              readOnly={display}
              onChange={handleOnChange}
              onFocus={onFocus}
              style={Icon ? { paddingLeft: 40 } : {}}
            />
          )}
          {ClearIcon && value && (
            <ClearIcon width={20} height={20} onClick={() => onChange({ name, value: '' })} />
          )}
        </div>
      </div>
    );
  }
);
